import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, Rocket, Sparkles, ArrowRight } from "lucide-react";

const CollabMessageSection = () => {
  return (
    <section className="relative h-[80vh] md:h-[75vh] w-full overflow-hidden font-body text-white">
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover brightness-[0.4]"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/videos/impact.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-transparent" />

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center items-start h-full max-w-5xl mx-auto px-6 space-y-6">
        <motion.h2
          className="text-3xl md:text-5xl font-bold font-heading"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Collaborate for Meaningful Impact
        </motion.h2>

        <motion.p
          className="text-base md:text-lg text-gray-200 max-w-2xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          Let’s co-create{" "}
          <span className="text-primary font-semibold">meaningful change</span> across sectors, communities,
          and systems through{" "}
          <span className="text-secondary font-semibold">resilient, future-ready solutions</span>.
        </motion.p>

        {/* Icons + Messages */}
        <motion.div
          className="flex flex-col md:flex-row gap-6 mt-4"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          {/* Message Box 1 */}
          <div className="flex items-start gap-4 p-4 bg-white/10 backdrop-blur-lg rounded-xl border border-white/10 w-full md:w-1/2">
            <div className="relative">
              <Lightbulb className="text-yellow-400 w-6 h-6" />
              <Sparkles className="absolute -top-1 -right-1 w-3 h-3 text-yellow-300 animate-pulse" />
            </div>
            <p className="text-sm md:text-base leading-relaxed text-white">
              Spark innovation through collaborative ideas.
            </p>
          </div>

          {/* Message Box 2 */}
          <div className="flex items-start gap-4 p-4 bg-white/10 backdrop-blur-lg rounded-xl border border-white/10 w-full md:w-1/2">
            <div className="relative">
              <Rocket className="text-green-400 w-6 h-6" />
              <div className="absolute -bottom-1 -right-1 w-2.5 h-2.5 bg-green-300 rounded-full animate-ping" />
            </div>
            <p className="text-sm md:text-base leading-relaxed text-white">
              Accelerate impact with real-world solutions.
            </p>
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.div
          className="mt-6"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <button className="flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-primary to-secondary text-white text-sm font-semibold shadow-lg hover:shadow-xl transition-all">
            Start Collaborating
            <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default CollabMessageSection;
